import { Modal } from '@/ui/Modal'

interface Props {
  src: string
  alt?: string
  onClose: () => void
}

export function ImageLightbox({ src, alt, onClose }: Props) {
  return (
    <Modal open={Boolean(src)} onClose={onClose} centered backdropClassName="bg-black/85 backdrop-blur-sm">
      <img
        src={src}
        alt={alt || 'Full size image'}
        className="max-w-[90vw] max-h-[90vh] object-contain rounded-2xl animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      />
    </Modal>
  )
}
